import { mergeStyles } from '@fluentui/react';

export const featurestorePageClassName = mergeStyles({
  padding: `50px 60px 20px`,
});
